/**
 * 占卜禁忌数据（双端共用：web 弹窗 / h5 弹层）
 *
 * 内容分六类禁忌 + 可占/不可占示例 + 总结，
 * 数据化便于产品侧调整文案，双端 UI 保持一致。
 */
/** 六类核心禁忌 */
export const TABOO_SECTIONS = [
    {
        name: '操作禁忌',
        items: [
            {
                title: '忌子时占卜（23:00-1:00）',
                desc: '子时为一日阴阳交接之时，气场混沌，易干扰判断。若紧急事项需占卜，需静心凝神后再起课。',
            },
            {
                title: '忌一事多占',
                desc: '同一问题短期反复占卜（尤其结果已明确时），被视为「渎神」，可能导致信息混乱。若第一次结果模糊，可隔日再占。',
            },
            {
                title: '忌心念不专',
                desc: '占卜时需专注默念所求之事（如：「问今日谈判成败」）。杂念纷扰或玩笑占卜，结果易失准。',
            },
        ],
    },
    {
        name: '内容禁忌',
        items: [
            {
                title: '不占他人隐私',
                desc: '禁止窥探他人私事（如婚姻、健康、财富细节），除非对方明确请求。强行占卜易损自身福报。',
            },
            {
                title: '不占生死大凶',
                desc: '涉及重病、生死、灾厄等极端问题，需谨慎对待。六神煞本为趋吉避凶之术，若占得大凶（如空亡+赤口），应止损而非深究。',
            },
            {
                title: '不占戏谑之事',
                desc: '如占卜娱乐、赌博、恶作剧等，轻则无效，重则反招不吉。',
            },
        ],
    },
    {
        name: '伦理禁忌',
        items: [
            {
                title: '忌替他人做决定',
                desc: '占卜结果仅为参考，不可代替他人决策（如「你必须离婚」）。需尊重他人自由意志，仅陈述趋势。',
            },
            {
                title: '忌恐吓或绝对化解读',
                desc: '避免用结果威胁他人（如「你必遭灾」）。凶兆应解读为「风险提示」，并建议化解之道（如留连宜推迟行动）。',
            },
        ],
    },
    {
        name: '特殊日禁忌',
        items: [
            {
                title: '自身气场混乱时不占',
                desc: '大病初愈、情绪极端（大悲大怒）、酒后或深夜精神涣散时，不宜占卜。',
            },
            {
                title: '传统忌日慎占',
                desc: '部分流派避用：四离日（二分二至前一日）、四绝日（四立前一日）、岁破日（年支冲日），认为天地气场不稳。',
            },
        ],
    },
    {
        name: '结果处理禁忌',
        items: [
            {
                title: '凶兆忌执迷',
                desc: '若占得凶象（如空亡），勿过度恐慌。应结合现实调整策略，而非盲目迷信结果。',
            },
            {
                title: '吉兆忌懈怠',
                desc: '占得吉兆（如速喜）仍要主动行动，不可坐等其成，否则易错失良机。',
            },
        ],
    },
    {
        name: '现代使用建议',
        items: [
            {
                title: '合法性底线',
                desc: '不用于煽动犯罪、破坏社会秩序（如占卜如何违法不被抓）。',
            },
            {
                title: '科学理性看待',
                desc: '占卜结果≠命运定数，而是提供另一种视角。重大决策需综合现实信息。',
            },
            {
                title: '案例警示',
                desc: '有人连续三日占问投资，得「速喜」「小吉」「赤口」，因结果矛盾加大投入，最终亏损。此犯「一事多占」与「凶兆执迷」二忌。',
            },
        ],
    },
];
/** 可占与不可占示例 */
export const TABOO_CASES = [
    { topic: '出行是否顺利', allow: 'yes', reason: '六神煞核心应用方向' },
    { topic: '疾病是否痊愈', allow: 'no', reason: '涉及生死，应交由医学' },
    { topic: '他人是否暗恋自己', allow: 'no', reason: '侵犯隐私' },
    { topic: '面试成败趋势', allow: 'yes', reason: '属事态发展预测' },
    { topic: '赌博输赢', allow: 'never', reason: '违背伦理，助长贪念' },
];
/** 禁忌总结（弹窗结尾） */
export const TABOO_SUMMARY = '禁忌本质是「敬天、尊人、守心」——敬规律不可亵玩，尊他人不可越界，守本心不可偏执。遵循此道，方为善用。';
//# sourceMappingURL=taboo.js.map